import { FormEvent, useState } from 'react';
import { signup, validatePassword } from '../../core/auth';
import { showError } from '../../core/utils';
import { HiOutlineEye, HiOutlineEyeSlash } from 'react-icons/hi2';

export default function SignupForm({ product, apiEndpoint, privacyHref, onSuccess, onError }: any) {
  const [requesting, setRequesting] = useState(false);
  const [pwdVisible, setPwdVisible] = useState(false);
  const [confirmPwdVisible, setConfirmPwdVisible] = useState(false);

  return (
    <form
      className="auth_form"
      onSubmit={async (event: FormEvent<HTMLFormElement>) => {
        try {
          event.preventDefault();
          setRequesting(true);
          const formData = new FormData(event.currentTarget);
          const email = (formData.get('email') as string || '').trim();
          const password = formData.get('password') as string;
          const confirmPassword = formData.get('confirm-password') as string;
          const confirmCheckbox = formData.get("confirmCheckbox");

          if (!confirmCheckbox) {
            showError("Bạn phải đồng ý với Chính sách bảo mật");
            return;
          }
          if (!validatePassword(password)) {
            showError("Mật khẩu phải chứa ít nhất 8 ký tự");
            return;
          }
          if (password !== confirmPassword) {
            showError("Mật khẩu xác nhận không khớp");
            return;
          }

          const data = await signup({
            email,
            password,
            productId: product?.code || product?.id,
          }, apiEndpoint);

          onSuccess(data);
        } catch (e: any) {
          showError(e?.response?.data || e);
          onError(e?.response?.data || e);
        } finally {
          setRequesting(false);
        }
      }}
    >
      <div className="form_field_group">
        <label className="field_label" htmlFor="signup-email">Email</label>
        <div className="form_item">
          <input
            type="email"
            id="signup-email"
            name="email"
            placeholder="Nhập email của bạn"
            autoComplete="email"
            required
          />
        </div>
      </div>

      <div className="form_field_group">
        <label className="field_label" htmlFor="signup-password">Mật khẩu</label>
        <div className="form_item">
          <input
            id="signup-password"
            name="password"
            type={pwdVisible ? 'text' : 'password'}
            placeholder="Tạo mật khẩu"
            autoComplete="new-password"
            required
          />
          <button
            type="button"
            className="password_eye_toggle"
            onClick={() => setPwdVisible(v => !v)}
            aria-label={pwdVisible ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'}
            tabIndex={-1}
          >
            {pwdVisible ? <HiOutlineEye /> : <HiOutlineEyeSlash />}
          </button>
        </div>
      </div>

      <div className="form_field_group">
        <label className="field_label" htmlFor="signup-confirm-password">Xác nhận mật khẩu</label>
        <div className="form_item">
          <input
            id="signup-confirm-password"
            name="confirm-password"
            type={confirmPwdVisible ? 'text' : 'password'}
            placeholder="Nhập lại mật khẩu"
            autoComplete="new-password"
            required
          />
          <button
            type="button"
            className="password_eye_toggle"
            onClick={() => setConfirmPwdVisible(v => !v)}
            aria-label={confirmPwdVisible ? 'Ẩn mật khẩu xác nhận' : 'Hiện mật khẩu xác nhận'}
            tabIndex={-1}
          >
            {confirmPwdVisible ? <HiOutlineEye /> : <HiOutlineEyeSlash />}
          </button>
        </div>
      </div>

      <div className="form_item checkbox">
        <label htmlFor="signup-confirmCheckbox">
          <input type="checkbox" id="signup-confirmCheckbox" name="confirmCheckbox" defaultChecked />
          <span>
            Tôi đồng ý với
            <a href={privacyHref} target="_blank" rel="noopener noreferrer"> Chính sách bảo mật</a>
          </span>
        </label>
      </div>

      <button type="submit" className="primary_btn" disabled={requesting}>
        Tạo tài khoản
      </button>
    </form>
  );
}
